import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useGetTagByName } from './queries';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';

const buildSearchUrl = ({ location, capacity, tag }) => {
  if (!tag?.slug) {
    return '/search?location=london';
  }

  return encodeURI(
    `/search?location=${location}&tag=${tag.slug}&capacity=${capacity}`,
  );
};

const getSearchData = thread => {
  const threadData = thread.data();
  const location = threadData._venue.location.slug;
  const tagName = threadData.event_type;
  const capacity = threadData.capacity;
  return { location, tagName, capacity };
};

const EnquiryInfoSuggestedVenues = ({ firstThread }) => {
  const [searchData, setSearchData] = useState({});
  const { data: tag } = useGetTagByName({
    enabled: !!searchData.tagName,
    name: searchData.tagName,
  });

  useEffect(() => {
    const fetchThreadAndTag = async () => {
      const thread = await inboxService.fetchThread(firstThread.data()._id);
      if (!thread) {
        return;
      }
      const searchData = getSearchData(thread);
      setSearchData(searchData);
    };

    fetchThreadAndTag().catch(console.error);
  }, [firstThread]);

  return (
    <Alert sx={{ mb: 1 }} severity='info' color='info'>
      <AlertTitle
        sx={{
          fontWeight: 700,
          lineHeight: 1.5,
          letterSpacing: '0.15px',
          color: 'rgba(0,0,0, .6)',
          mb: 2,
        }}>
        Find the perfect venue
      </AlertTitle>
      <Typography variant='body1' mb={1.5} sx={{ color: 'rgba(0,0,0, .6)' }}>
        We recommend contacting at least 4 venues to have the best chance of
        finding the perfect venue
      </Typography>
      <Button
        sx={{ m: 0 }}
        href={buildSearchUrl({ ...searchData, tag })}
        variant='contained'
        color='info'
        size='small-medium'>
        See recommended venues
      </Button>
    </Alert>
  );
};

export default EnquiryInfoSuggestedVenues;
